var locale, real, langPath;

if (typeof window.poskiLocale == "undefined") {
    window.poskiLocale = {
        locale: 'cs'
    };
}

locale = window.poskiLocale;
real = window.poskiReal;
langPath = window.poskiLangPath;

window.parseCena = function (text) {
    return text ? parseFloat(text.replace(/\s/g, '')) : '';
};

window.formatCena = function (number) {
    var regex = /(\d+)(\d{3})/;

    number = number.toString();
    while (regex.test(number)) {
        number = number.replace(regex, '$1 $2');
    }
    return number;
};

window.SumoSelect = function () {
    $('select').SumoSelect({
        placeholder: locale.sumo_select_vyberte,
        captionFormat: '{0} ' + locale.sumo_select_vybrano,
        captionFormatAllSelected: '{0} ' + locale.sumo_select_vse_vybrano,
        csvDispCount: 2,
        locale: [locale.sumo_select_ok, locale.sumo_select_zrusit, locale.sumo_select_oznacit_vse],
    });

    $('select[data-placeholder]').each(function (i, el) {
        var $select = $(el);
        $select.closest('.SumoSelect').find('span.placeholder').html($select.data('placeholder'))
    });
};

window.formatCenaInInput = function (selector, povolitZnaky, zapornaCisla) {
    var $element = $(selector);
    $element.keyup(function () {
        if (typeof povolitZnaky == 'undefined' || (povolitZnaky && !isNaN($element.val().replace(' ', '').replace('.', ',')))) {
            var reg = /[^0-9 ]/;
            if (zapornaCisla) {
                reg = /[^0-9 \-]/;
            }
            var $number = $element.val().replace(reg, ''); // odstranime znaky, pokud to nejsou cisla nebo mezera
            if ($number != '') {
                $element.val(formatCena(parseCena($number)));
                $element.css({
                    'text-align': 'right'
                });
            }
        }
    });
    if ($element.val() != '' && typeof povolitZnaky == 'undefined') {
        $element.val(formatCena(parseCena($element.val())));
    }
};

window.URL_add_parameter = function (url, param, value) {
    var hash = {};
    var parser = document.createElement('a');

    parser.href = url;

    var parameters = parser.search.split(/\?|&/);

    for (var i = 0; i < parameters.length; i++) {
        if (!parameters[i])
            continue;

        var ary = parameters[i].split('=');
        hash[ary[0]] = ary[1];
    }

    hash[param] = value;

    var list = [];
    Object.keys(hash).forEach(function (key) {
        list.push(key + '=' + hash[key]);
    });

    parser.search = '?' + list.join('&');
    return parser.href;
}

/*encoding: utf-8 */
$(document).ready(function () {

    // sledovani udalosti
    window.trackFrontendEvent = function (controller, event, data) {
        return $.ajax({
            'url': langPath + '@track?c=' + controller + '&ev=' + event,
            'data': data,
            'type': 'get',
            'dataType': 'json'
        });
    };

    $('select').bind('options-change', function (ev) {
        $(ev.currentTarget)[0].sumo.reload();
    });

    // prettyselect
    window.SumoSelect();

    // vypočti stejnou výšku na elementy

        window.matchHeight = function () {
            if ($.fn.matchHeight) {
                $('.js-sameHeight').matchHeight();
            }
        };
        window.matchHeight();

    // h5 validace
    if ($.fn.h5Validate) {
        (function () {
            $('.JS-generated-form-validation').h5Validate();
        }());
    };


    // lazyloading
    window.lazyLoad = function () {
        if (typeof LazyLoad !== 'undefined') {
            var myLazyLoad = new LazyLoad({
                elements_selector: ".js-lazy",
                load_delay: 300
            });
        }
    };
    window.lazyLoad();


    // kotva ve vypisu nemovitosti
    (function () {
        var nastavitKotvuDoURL = function (ev) {
            var $el = $(ev.currentTarget);
            if (!$(ev.target).is('.owl-next, .owl-prev')) {
                if ($el.attr('id')) {
                    var urlSplit = location.href.split('#');
                    location.href = urlSplit[0] + '#' + $el.attr('id')
                }
            }
        }

        $('.js-estateListItem').on('click', function (ev) {
            nastavitKotvuDoURL(ev);
        });

        $('.js-estateList-main').delegate('.js-estateListItem', 'click', function (ev) {
            nastavitKotvuDoURL(ev);
        });
    }());

    if ($.fn.lightGallery) {
        (function () {
            $(".JS-lightgallery").lightGallery({
                selector: '.JS-lightgallery-item',
                thumbnail: true,
                animateThumb: true,
                showThumbByDefault: false,
                zoom: true,
                exThumbImage: 'data-exthumbimage',
                closable: false,
            });

            $(".thumbnail-container").lightGallery();
        }());
    };

    // volání záložek
    if ($.fn.responsiveTabs) {
        (function () {
            var $tabs = $('.JS-responsiveTabs');
            if ($tabs.length === 0)
                return;
            $tabs.responsiveTabs();
        }());
    };

    // lišta cookies
    (function () {
        if ($('#js-cookie-consent').length == 0)
            return;

        var setLinks = document.querySelectorAll('.js-cookie-consent-set');
        for (var i = 0; i < setLinks.length; i++) {
            setLinks[i].addEventListener('click', function (event) {
                var r = new XMLHttpRequest();
                r.open("GET", event.target.href, true);
                r.send();
                event.preventDefault();
                document.getElementById('js-cookie-consent').style.display = 'none';
            });
        }
    })();

    // pro generovane menu
    (function () {
        if ($('.JS-menu').length == 0)
            return;
        $('.JS-menu').find('li.active').parents('li').addClass('active');
    })();

    // pro nemovitosti v levem menu ve statech
    if ($.fn.responsiveTabs) {
        (function () {
            if ($('.JS-responsiveTabs-2').length == 0)
                return;

            var option = {};
            if ($('.JS-responsiveTabs-2').data('active') && $('.JS-responsiveTabs-2 ul li').length > 1) {
                option['active'] = 1;
            }

            $('.JS-responsiveTabs-2').responsiveTabs(option);
        })();
    };

    (function () { // resize mapy
        var $zalozka = $('.JS-responsiveTabs').find('a[href="#mapa"], a[href="#projekty2-mapa"]');
        $zalozka.click(function () {
            var $map = $('.GoogleMap');
            var gmMap = $map.data('gmMap');
            var zoom = $map.data('gmZoom');

            if (typeof gmMap != 'undefined') {
                window.google.maps.event.trigger(gmMap, 'resize');
                var bounds = new window.google.maps.LatLngBounds();

                if ($map.data('gmMarkers')) {
                    $.each($map.data('gmMarkers'), function () {
                        bounds.extend(this.getPosition());
                    });
                }
                if ($map.data('gmPolygons')) {
                    $.each($map.data('gmPolygons'), function () {
                        this.getPath().forEach(function (latlng, i) {
                            bounds.extend(latlng);
                        });
                    });
                }
                gmMap.fitBounds(bounds);

                if (zoom) {
                    gmMap.setZoom(zoom);
                }
            }

        });
    }());

    (function () {
        var favoriteClick = function ($this) {

            var active = $this.is('.active');
            var id_zs = $this.data('id_zs');

            $.ajax({
                url: locale.url_favorite,
                data: {
                    id_zs: id_zs,
                    delete: active ? 1 : 0
                },
                success: function (data) {
                    $this.toggleClass('active');
                    $this.closest('div').find('.js-nemovitosti-takeout').removeClass('active');
                    if (data == 0) {
                        $('.js-favorite-link').hide();
                        $('.location_nemovitosti.action_favorite .estates-container').html('<div class="alert alert-info"><p>V oblíbených nabídkách nemáte žándé další nabídky</p></div>');
                    } else {
                        $('.js-favorite-link').show();
                    }
                    $('.js-favorite-link .count').text(data);
                    if ($('body').is('.action_favorite')) {
                        $this.closest('.js-estateListItem').remove();
                    }
                },
                error: function (data) {
                    $this.css({
                        'backgound': 'red'
                    });
                }
            });
        };

        $('body').delegate('.js-nemovitosti-favorite', 'click', function (ev) {
            ev.preventDefault();
            favoriteClick($(this));
        });
    }());


    (function () {
        var takeoutClick = function ($this) {
            var active = $this.is('.active');
            var id_zs = $this.data('id_zs');

            $.ajax({
                url: locale.url_takeout,
                data: {
                    id_zs: id_zs,
                    delete: active ? 1 : 0
                },
                success: function (data) {
                    $this.toggleClass('active');
                    $this.closest('div').find('.js-nemovitosti-favorite').removeClass('active');
                    if (data == 0) {
                        $('.js-takeout-link').hide();
                        $('.location_nemovitosti.action_takeout .estates-container').html('<div class="alert alert-info"><p>V odebraných nabídkách nemáte žándé další nabídky</p></div>');
                    } else {
                        $('.js-takeout-link').show();
                    }
                    $('.js-takeout-link .count').text(data);
                    $this.closest('.js-estateListItem').remove();
                },
                error: function (data) {
                    $this.css({
                        'backgound': 'red'
                    });
                }
            });
        };

        $('body').delegate('.js-nemovitosti-takeout', 'click', function (ev) {
            ev.preventDefault();
            takeoutClick($(this));
        });
    }());

    // zastupne texty u selectu
    (function () {
        var selector = 'select[name="pobvod"], select[name="stari"], select[name="pobocka"], select[name="typsmlouvy"], select[name="typnemovitosti"], select[name="kraj"], select[name="okres"], select[name="obec"], select[name="cobce"], select[name="dispozice"]';
        $('body').delegate(selector, 'focus blur change', function (ev) {
            var $select = $(ev.currentTarget);

            $select.find('option').addClass('normal').filter(':first').removeClass('normal').addClass('placeholder');
            if ($select.find('option:first').is(':selected')) {
                $select.addClass('placeholder');
            } else {
                $select.removeClass('placeholder');
            }
        });
        $(selector).trigger('blur');
    }());

    // odesilani na zmenu, schovani submitu ve vypisu
    (function () {
        var $forms = $('form').filter('#nemovitosti-sort, #nemovitosti-limit, #hledame-filter');

        $forms.find('select').bind('change', function (ev) {
            $(ev.target).closest('form').trigger('submit');
        });

        $forms.find('.submit').hide();
    }());

    (function () { // odesilani na zmenu, schovani submitu ve vypisu
        var $elements = $('.AutoSubmit');

        $elements.bind('change', function (ev) {
            $(ev.target).closest('form').trigger('submit');
        });
    }());

    (function () { // tlacitka Zpet
        $('.JS-back-history').bind('click', function (ev) {
            window.history.back(-1);
            ev.preventDefault();
        });
    }());

    (function () { // tisk
        $('.JS-print').bind('click', function (ev) {
            window.print();
            ev.preventDefault();
        });
    }());

    (function () {
        if (typeof window.prNemovitostMapsItems !== 'undefined') {
            var options = (window.prNemovitostMapsOptions !== 'undefined' ? window.prNemovitostMapsOptions : {});
            PRNemovitostiMaps.initialize(window.prNemovitostMapsItems, options);
            PRNemovitostiMaps.run();
        }
    }());

    $(".js-scroll").click(function (event) {
        event.preventDefault();

        var headerHeight = 0;

        if($('.js-header-fixed').length) {
            headerHeight = $('.js-header-fixed').height();
        }

        var full_url = this.href;
        var parts = full_url.split("#");
        var trgt = parts[1];
        var target_offset = $("#" + trgt).offset();
        var target_top = target_offset.top;
        $('html, body').animate({
            scrollTop: target_top - headerHeight
        }, 1500, 'easeInSine');
    });

    if (window.setting.FRONTEND_SETTING_FRAME_SCROLL_UP && document.body.clientWidth > 800) {
        $(function () { // scroll UP tlačítko
            var $a = $('<a/>').addClass('scrollup').hide();
            $('body').append($a);

            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('.scrollup').fadeIn();
                } else {
                    $('.scrollup').fadeOut();
                }
            });
            $('.scrollup').click(function () {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
                return false;
            });
        });
    }

    // individualni stranka FAQs
    (function () {
        $('.js-page-faq').click(function () {
            $(this).find('.description').toggle();
            $(this).toggleClass('show');
        });
    }());

    (function () {
        var $content = $('.js-marketing-content');
        if ($content.length === 0) {
            return;
        }

        var page_location = $content.data('page-location');
        var page_locale = $content.data('page-locale');

        $.ajax({
            url: '/@marketing-code',
            data: {
                'page-location': page_location,
                'page-locale': page_locale
            },
            success: function (html) {
                if (html) {
                    $content.html(html);
                }
            }
        });
    }());
});
